import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as filesDemo from '../files-demo'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: filesDemo.RESOURCE.payload.dimension.partialId,
      partialId: filesDemo.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Sandbox attribute for manually testing the Files attribute component',
    isOptional: true,
    name: 'Documents',
    partialId: PartialId.Standard.create('documents'),
    type: { isFile: true },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
